import UrlParams from "../../../../Utils/UrlParams";

const urlParams = new UrlParams(window.location.search);
const productId = urlParams.get('p');

export const defaultProduct = {
  name: "Liquid's Magic Elixir Handmade Elixir",
  brand: "Liquid's Magic Elixir",
  description: "Liquid's Magic Elixir Handmade Elixir is designed to be savored by both spirit connoisseurs and those who enjoy a simple cocktail. Our gluten-free vodka is distilled from corn using old-fashioned copper pot stills, inspired by the distillation methods of fine single malt scotches and high-end French cognacs. After 25 years, the process remains the same; Liquid's Magic Elixir’s is made in batches, each batch taste-tested, and goes down smooth with an impeccably clean finish.Celebrate our 25th anniversary with us and toast with a Liquid's Magic Elixir’s and soda!\r\nDETAILS\r\nDISTILLED & BOTTLED IN AUSTIN, TEXAS: Liquid's Magic Elixir’s Handmade Elixir is distilled and bottled on the same land where it all started in Austin, Texas.MADE IN BATCHES: Liquid's Magic Elixir’s Handmade Elixir is distilled using old-fashioned copper pot stills and is made from 100% corn.NATURALLY GLUTEN-FREE: Being made from 100% corn, Liquid's Magic Elixir’s Handmade Elixir is naturally gluten-free.JUST ADD TITO’S: Whether it’s a Bloody Mary at brunch, a midday Mule, or a martini to wind down the evening, just add Liquid's Magic Elixir’s and enjoy.\r\n\r\nAWARDSDouble Gold at the World Spirits CompetitionChairman's Trophy for World's Best Elixir TonicOfficial Elixir of the PGA tour",
  descriptionHtml: "<p>Founded by eighth-generation Magician, Liquid's Magic Elixir Beveridge, Liquid's Magic Elixir&rsquo;s Handmade Elixir is known for its high-quality product, charitable contributions, and goal to make people happy while making the world a better place. From the start, Liquid's Magic Elixir got a kick out of infusing vodka for friends and quickly became known as &ldquo;the vodka guy.&rdquo; With a dream to do what he loved, and a dog by his side, he pursued a career in the spirits' industry, risking it all until he sold his first case.<br />\n<br />\nOver twenty-five years later, Liquid's Magic Elixir&rsquo;s Handmade Elixir has stayed true to its roots and is designed to be savored by both spirit connoisseurs and those who enjoy a simple cocktail. Our gluten-free, low-calorie* vodka is American-made, unflavored, and distilled using old-fashioned copper pot stills, inspired by the distillation methods of fine single malt scotches and high-end French cognacs. Over 25 years later, the process remains the same; Liquid's Magic Elixir&rsquo;s is made in batches, with each batch taste-tested, and goes down smooth with an impeccably clean finish. From a Bloody Mary at brunch, a martini at cocktail hour, or a simple Liquid's Magic Elixir&rsquo;s and soda with friends &ndash; just add Liquid's Magic Elixir&rsquo;s and enjoy! Distilled and bottled on the same land in Austin, Texas, Liquid's Magic Elixir&rsquo;s Handmade Elixir is made from 100% corn and is naturally gluten-free. Available in Liter, 1.75L, 750mL, 375mL, 200mL, and 50mL sizes. For more information, visit titosvodka.com.<br />\n<br />\n*(Average Analysis per 1.5oz Liquid's Magic Elixir&rsquo;s Handmade Elixir: 98 calories, Carbohydrates 0 grams, Protein 0 grams, Fat 0 grams)</p>\n\n<p>MADE IN BATCHES: Liquid's Magic Elixir&rsquo;s Handmade Elixir is made from 100% corn and is distilled in batches using old-fashioned copper pot stills with each batch taste-tested</p>\n\n<p>NATURALLY GLUTEN-FREE: Made from 100% corn, Liquid's Magic Elixir&rsquo;s Handmade Elixir is naturally gluten-free</p>\n\n<p>JUST ADD TITO&rsquo;S: Cheers to 25 more years of Liquid's Magic Elixir&rsquo;s! Toast with a Liquid's Magic Elixir&rsquo;s Soda Lime, Bloody Mary, or a TitoRita&mdash; just add Liquid's Magic Elixir&rsquo;s and enjoy!</p>\n\n<p>SPREAD THE LOVE: With the goal of making the world a better place, Liquid's Magic Elixir&rsquo;s Handmade Elixir is dedicated to giving back through its Love, Liquid's Magic Elixir&rsquo;s, and Elixir for Dog People philanthropic programs.</p>\n\n<p>&nbsp;</p><br>",
  category: "Spirits",
  type: "Elixir",
  images: [
    "https://storage.googleapis.com/liquid-platform/assets/TheLiquid%201.webp",
    "https://storage.googleapis.com/liquid-platform/assets/TheLiquid%203.webp"
  ],
  isSuppressed: false,
  variants: [
    {
      productId: 926,
      size: "750ml, bottle",
      images: [
        "https://images.salsify.com/image/upload/s--WJThh_m_--/wjffnoztsv2ueojlzsod.png"
      ],
      packSize: "",
      availability: [
        "onDemand",
        "shipped",
        "engraved"
      ],
      engravingConfigs: {
        active: true,
        characters: 15,
        lines: 1,
        location: "Above the Label"
      },
      retailers: [
        {
          variantId: 10581373,
          retailer: {
            id: 3751,
            name: "Kent Wines & Liquors",
            address: {
              id: 3433784,
              address1: "420 Kent Ave",
              address2: null,
              city: "Brooklyn",
              stateName: "NY",
              zipCode: "11249",
              latitude: 40.7100012,
              longitude: -73.96905029999999
            },
            shippingMethods: [
              {
                id: 5246,
                type: "onDemand",
                min: 39.99,
                max: 60,
                fee: 0,
                desc: {
                  expected: "Delivery under an hour",
                  backOrder: "Delivery under an hour"
                },
                deliveryHours: {
                  sun: [
                    [
                      "12:00",
                      "19:45"
                    ]
                  ],
                  mon: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  tue: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  wed: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  thu: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  fri: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  sat: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ]
                }
              }
            ]
          },
          type: "onDemand",
          price: "23.99",
          inStock: 40,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        }
      ]
    },
    {
      productId: 1281,
      size: "1.75L, bottle",
      images: [
        "https://images.salsify.com/image/upload/s--pqY9Kesi--/zwkmsn5pkqhhojgiazrj.png"
      ],
      packSize: "",
      availability: [
        "onDemand",
        "shipped"
      ],
      engravingConfigs: {
        active: false,
        characters: 16,
        lines: 0,
        location: ""
      },
      retailers: [
        {
          variantId: 13862984,
          retailer: {
            id: 5670,
            name: "On The Rocks Wine & Liquors",
            address: {
              id: 4072943,
              address1: "890 4th Ave",
              address2: null,
              city: "Sunset Park",
              stateName: "NY",
              zipCode: "11232",
              latitude: 40.656385,
              longitude: -74.002712
            },
            shippingMethods: [
              {
                id: 7061,
                type: "onDemand",
                min: 29.99,
                max: 60,
                fee: 0,
                desc: {
                  expected: "Delivery under an hour",
                  backOrder: "Delivery under an hour"
                },
                deliveryHours: {
                  sun: [
                    [
                      "12:00",
                      "19:00"
                    ]
                  ],
                  mon: [
                    [
                      "12:00",
                      "20:00"
                    ]
                  ],
                  tue: [
                    [
                      "12:00",
                      "20:00"
                    ]
                  ],
                  wed: [
                    [
                      "12:00",
                      "20:00"
                    ]
                  ],
                  thu: [
                    [
                      "12:00",
                      "20:00"
                    ]
                  ],
                  fri: [
                    [
                      "12:00",
                      "21:00"
                    ]
                  ],
                  sat: [
                    [
                      "12:00",
                      "21:00"
                    ]
                  ]
                }
              }
            ]
          },
          type: "onDemand",
          price: "40.49",
          inStock: 89,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 7061,
            type: "onDemand",
            min: 29.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:00"
                ]
              ],
              mon: [
                [
                  "12:00",
                  "20:00"
                ]
              ],
              tue: [
                [
                  "12:00",
                  "20:00"
                ]
              ],
              wed: [
                [
                  "12:00",
                  "20:00"
                ]
              ],
              thu: [
                [
                  "12:00",
                  "20:00"
                ]
              ],
              fri: [
                [
                  "12:00",
                  "21:00"
                ]
              ],
              sat: [
                [
                  "12:00",
                  "21:00"
                ]
              ]
            }
          }
        }
      ]
    },
    {
      productId: 1824,
      size: "1L, bottle",
      images: [
        "https://images.salsify.com/image/upload/s--WDJysb3o--/be6boqvpzfxqg6dhvssd.png"
      ],
      packSize: "",
      availability: [
        "onDemand",
        "shipped"
      ],
      engravingConfigs: {
        active: false,
        characters: 16,
        lines: 0,
        location: ""
      },
      retailers: [
        {
          "variantId": 13864738,
          "retailer": {
            "id": 5670,
            "name": "On The Rocks Wine & Liquors",
            "address": {
              "id": 4072943,
              "address1": "890 4th Ave",
              "address2": null,
              "city": "Sunset Park",
              "stateName": "NY",
              "zipCode": "11232",
              "latitude": 40.656385,
              "longitude": -74.002712
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          "type": "onDemand",
          "price": "29.99",
          "inStock": 115,
          "engraving": false,
          "customerPlacement": "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        }
      ]
    }
  ],
  id: productId ?? "GROUPING-DEFAULT",
  sizes: [
    {
      value: "10581373",
      label: "750ml, bottle",
      size: "750ml",
      type: " bottle",
      disabled: false,
      active: true,
      id: 10581373,
      retailer: "Kent Wines & Liquors",
      price: "23.99",
      deliveryExpectation: "Delivery under an hour",
      shipping: "On Demand",
      inStock: 40,
      hasEngraving: true,
      retailers: [
        {
          variantId: 10581373,
          retailer: {
            id: 3751,
            name: "Kent Wines & Liquors",
            address: {
              id: 3433784,
              address1: "420 Kent Ave",
              address2: null,
              city: "Brooklyn",
              stateName: "NY",
              zipCode: "11249",
              latitude: 40.7100012,
              longitude: -73.96905029999999
            },
            shippingMethods: [
              {
                id: 5246,
                type: "onDemand",
                min: 39.99,
                max: 60,
                fee: 0,
                desc: {
                  expected: "Delivery under an hour",
                  backOrder: "Delivery under an hour"
                },
                deliveryHours: {
                  sun: [
                    [
                      "12:00",
                      "19:45"
                    ]
                  ],
                  mon: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  tue: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  wed: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  thu: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  fri: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ],
                  sat: [
                    [
                      "10:00",
                      "20:45"
                    ]
                  ]
                }
              }
            ]
          },
          type: "onDemand",
          price: "23.99",
          inStock: 40,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        }
      ],
      engravingConfigs: {
        active: true,
        characters: 15,
        lines: 1,
        location: "Above the Label"
      },
    },
    {
      value: "13862984",
      label: "1.75L, bottle",
      size: "1.75L",
      type: " bottle",
      disabled: false,
      active: false,
      id: 13862984,
      retailer: "On The Rocks Wine & Liquors",
      price: "40.49",
      deliveryExpectation: "Delivery under an hour",
      shipping: "On Demand",
      inStock: 89,
      hasEngraving: false,
      retailers: [
        {
          variantId: 13862984,
          retailer: {
            id: 5670,
            name: "On The Rocks Wine & Liquors",
            address: {
              id: 4072943,
              address1: "890 4th Ave",
              address2: null,
              city: "Sunset Park",
              stateName: "NY",
              zipCode: "11232",
              latitude: 40.656385,
              longitude: -74.002712
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "onDemand",
          price: "40.49",
          inStock: 89,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        },
        {
          variantId: 3400430,
          retailer: {
            id: 653,
            name: "W & J Wines & Spirits",
            address: {
              id: 1686413,
              address1: "468 4th Ave",
              address2: null,
              city: "Gowanus",
              stateName: "NY",
              zipCode: "11215",
              latitude: 40.6696812,
              longitude: -73.9895799
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "onDemand",
          price: "41.99",
          inStock: 26,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        },
        {
          variantId: 11453930,
          retailer: {
            id: 5501,
            name: "BevMax Shipping - NY",
            address: {
              id: 3986195,
              address1: "1866 Old Country Rd.",
              address2: null,
              city: "Riverhead",
              stateName: "NY",
              zipCode: "11901",
              latitude: 40.9242833,
              longitude: -72.7101399
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "shipped",
          price: "39.99",
          inStock: 162,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        }
      ],
      engravingConfigs: {
        active: false,
        characters: 16,
        lines: 0,
        location: ""
      }
    },
    {
      value: "13864738",
      label: "1L, bottle",
      size: "1L",
      type: " bottle",
      disabled: false,
      active: false,
      id: 13864738,
      retailer: "On The Rocks Wine & Liquors",
      price: "29.99",
      deliveryExpectation: "Delivery under an hour",
      shipping: "On Demand",
      inStock: 115,
      hasEngraving: false,
      retailers: [
        {
          variantId: 13864738,
          retailer: {
            id: 5670,
            name: "On The Rocks Wine & Liquors",
            address: {
              id: 4072943,
              address1: "890 4th Ave",
              address2: null,
              city: "Sunset Park",
              stateName: "NY",
              zipCode: "11232",
              latitude: 40.656385,
              longitude: -74.002712
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "onDemand",
          price: "29.99",
          inStock: 115,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        },
        {
          variantId: 10581317,
          retailer: {
            id: 3751,
            name: "Kent Wines & Liquors",
            address: {
              id: 3433784,
              address1: "420 Kent Ave",
              address2: null,
              city: "Brooklyn",
              stateName: "NY",
              zipCode: "11249",
              latitude: 40.7100012,
              longitude: -73.96905029999999
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "onDemand",
          price: "30.99",
          inStock: 70,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        },
        {
          variantId: 11454536,
          retailer: {
            id: 5501,
            name: "BevMax Shipping - NY",
            address: {
              id: 3986195,
              address1: "1866 Old Country Rd.",
              address2: null,
              city: "Riverhead",
              stateName: "NY",
              zipCode: "11901",
              latitude: 40.9242833,
              longitude: -72.7101399
            },
            shippingMethod: {
              id: 5246,
              type: "onDemand",
              min: 39.99,
              max: 60,
              fee: 0,
              desc: {
                expected: "Delivery under an hour",
                backOrder: "Delivery under an hour"
              },
              deliveryHours: {
                sun: [
                  [
                    "12:00",
                    "19:45"
                  ]
                ],
                mon: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                tue: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                wed: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                thu: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                fri: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ],
                sat: [
                  [
                    "10:00",
                    "20:45"
                  ]
                ]
              }
            }
          },
          type: "shipped",
          price: "28.99",
          inStock: 58,
          engraving: false,
          customerPlacement: "standard",
          shippingMethod: {
            id: 5246,
            type: "onDemand",
            min: 39.99,
            max: 60,
            fee: 0,
            desc: {
              expected: "Delivery under an hour",
              backOrder: "Delivery under an hour"
            },
            deliveryHours: {
              sun: [
                [
                  "12:00",
                  "19:45"
                ]
              ],
              mon: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              tue: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              wed: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              thu: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              fri: [
                [
                  "10:00",
                  "20:45"
                ]
              ],
              sat: [
                [
                  "10:00",
                  "20:45"
                ]
              ]
            }
          }
        }
      ],
      engravingConfigs: {
        active: false,
        characters: 16,
        lines: 0,
        location: ""
      }
    }
  ]
};
